import { Box, Button, Typography } from "@mui/material";
import './styles.css'

const ActivityCard = (props: any) => {
    const { imageUrl, title, onClick, buttonText, activityCardKey, children } = props
    return (
        <Box className={'activity-card'} key={activityCardKey}>
            <Box className={'activity-image'} sx={{
                background: `url(${imageUrl})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundOrigin: "content-box",
                backgroundPosition: "center",
            }}/>
            <Box className="activity-card-info">
                <Typography className="activity-title">
                    {title}
                </Typography>

                <Button variant="outlined" className="activity-card-button" onClick={onClick}>
                    {buttonText ? buttonText: 'Book Ticket'}
                </Button>
                {
                    children
                }
            </Box>
        </Box>
    )
}

export default ActivityCard;